import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import ProtectedRoute, { getRoleHomePage } from "./ProtectedRoute"

import LandingPage from "../pages/public/LandingPage"
import LoginPage from "../pages/auth/LoginPage"

import DashboardPage from "../pages/dashboard/DashboardPage"
import DashboardProPage from "../pages/dashboard/DashboardProPage"
import MaisonDjoDashboardPage from "../pages/dashboard/MaisonDjoDashboardPage"
import DepotRelaisDashboardPage from "../pages/dashboard/DepotRelaisDashboardPage"
import AgentCommercialDashboardPage from "../pages/dashboard/AgentCommercialDashboardPage"
import WarehouseDashboardPage from "../pages/dashboard/WarehouseDashboardPage"
import LogisticsDashboardPage from "../pages/dashboard/LogisticsDashboardPage"

import OrganizationsPage from "../pages/organizations/OrganizationsPage"
import ProductsPage from "../pages/products/ProductsPage"
import SalesPage from "../pages/sales/SalesPage"
import SalesListPage from "../pages/sales/SalesListPage"
import SaleDetailPage from "../pages/sales/SaleDetailPage"
import StoresPage from "../pages/stores/StoresPage"
import CustomersPage from "../pages/customers/CustomersPage"
import CategoriesPage from "../pages/categories/CategoriesPage"
import WarehousesPage from "../pages/warehouses/WarehousesPage"

import ProductPricesPage from "../pages/settings/ProductPricesPage"

import StockOrdersPage from "../pages/stock-orders/StockOrdersPage"
import StockBalancesPage from "../pages/stock-balances/StockBalancesPage"
import StockAlertsPage from "../pages/stock-alerts/StockAlertsPage"
import StockMovementsPage from "../pages/stock-movements/StockMovementsPage"
import StockTransfersPage from "../pages/stock-transfers/StockTransfersPage"
import StockAuditsPage from "../pages/stockAudits/StockAuditsPage"

import PaymentsPage from "../pages/payments/PaymentsPage"
import DepositsPage from "../pages/deposits/DepositsPage"
import ExpensesPage from "../pages/expenses/ExpensesPage"
import DebtsPage from "../pages/debts/DebtsPage"
import DebtPaymentsPage from "../pages/debt_payments/DebtPaymentsPage"
import StoreReconciliationsPage from "../pages/store_reconciliations/StoreReconciliationsPage"

import VehiclesPage from "../pages/logistics/VehiclesPage"
import DriversPage from "../pages/logistics/DriversPage"
import DeliveryTripsPage from "../pages/logistics/DeliveryTripsPage"

import ActivityLogsPage from "../pages/activityLogs/ActivityLogsPage"
import RolesPage from "../pages/roles/RolesPage"
import UsersPage from "../pages/users/UsersPage"
import ReportingPage from "../pages/reporting/ReportingPage"
import EmployeesPage from "../pages/hr/EmployeesPage"
import DepartmentsPositionsPage from "../pages/hr/DepartmentsPositionsPage"
import AttendancePage from "../pages/hr/AttendancePage"
import LeaveRequestsPage from "../pages/hr/LeaveRequestsPage"
import PayrollPage from "../pages/hr/PayrollPage"
import ContractsDocumentsPage from "../pages/hr/ContractsDocumentsPage"
import PerformancePage from "../pages/hr/PerformancePage"
import HrDashboardPage from "../pages/hr/HrDashboardPage"



// =========================================================
// COMPTABILITÉ & FINANCE
// =========================================================

import AccountingDashboardPage from "../pages/accounting/AccountingDashboardPage"
import ChartOfAccountsPage from "../pages/accounting/ChartOfAccountsPage"
import JournalEntriesPage from "../pages/accounting/JournalEntriesPage"
import GeneralLedgerPage from "../pages/accounting/GeneralLedgerPage"
import TrialBalancePage from "../pages/accounting/TrialBalancePage"


// =========================================================
// ACHATS & FOURNISSEURS
// =========================================================

import SuppliersPage from "../pages/purchasing/SuppliersPage"
import PurchaseRequestsPage from "../pages/purchasing/PurchaseRequestsPage"
import PurchaseOrdersPage from "../pages/purchasing/PurchaseOrdersPage"
import PurchaseReceiptsPage from "../pages/purchasing/PurchaseReceiptsPage"
import SupplierInvoicesPage from "../pages/purchasing/SupplierInvoicesPage"
import SupplierPaymentsPage from "../pages/purchasing/SupplierPaymentsPage"


// =========================================================
// PRODUCTION
// =========================================================

import ProductionBomsPage from "../pages/production/ProductionBomsPage"
import ProductionOrdersPage from "../pages/production/ProductionOrdersPage"


// =========================================================
// RÔLES GÉNÉRAUX
// =========================================================

const ALL_ADMIN = ["platform_admin", "super_admin"]

const GLOBAL_MANAGEMENT_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
]

const PRICE_SETTINGS_ROLES = [
  ...GLOBAL_MANAGEMENT_ROLES,
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const LOGISTICS_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
]

const AGENT_ROLES = ["agent_commercial"]


// =========================================================
// MAISON DJO
// =========================================================

const MAISON_DJO_ADMIN_ROLES = [
  "admin_maison_djo",
  "gestionnaire_maison_djo",
]

const MAISON_DJO_STOCK_ROLES = [
  "stock_maison_djo",
  "livreur_maison_djo",
]

const MAISON_DJO_ROLES = [
  ...MAISON_DJO_ADMIN_ROLES,
  ...MAISON_DJO_STOCK_ROLES,
]


// =========================================================
// DÉPÔT RELAIS
// =========================================================

const DEPOT_RELAIS_ADMIN_ROLES = [
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const DEPOT_RELAIS_STOCK_ROLES = ["stock_depot_relais"]

const DEPOT_RELAIS_MANAGER_ROLES = [
  ...DEPOT_RELAIS_ADMIN_ROLES,
  ...DEPOT_RELAIS_STOCK_ROLES,
]


// =========================================================
// SHOPS
// =========================================================

const SHOP_MAISON_DJO_ROLES = ["gerant_magasin"]
const SHOP_DEPOT_RELAIS_ROLES = ["gerant_depot_relais"]


// =========================================================
// PILOTAGE
// =========================================================

const PILOTAGE_ROLES = [
  ...GLOBAL_MANAGEMENT_ROLES,
  "viewer",
]

const AGENT_DASHBOARD_ROLES = [
  ...GLOBAL_MANAGEMENT_ROLES,
  ...AGENT_ROLES,
]

const MAISON_DJO_DASHBOARD_ROLES = [
  ...ALL_ADMIN,
  ...MAISON_DJO_ADMIN_ROLES,
]

const DEPOT_RELAIS_DASHBOARD_ROLES = [
  ...GLOBAL_MANAGEMENT_ROLES,
  ...DEPOT_RELAIS_MANAGER_ROLES,
]


// =========================================================
// CATALOGUE
// =========================================================

const CATALOGUE_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_operations",
  "gestionnaire_stock",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "stock_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
  "stock_depot_relais",
]


// =========================================================
// STRUCTURE
// =========================================================

const STRUCTURE_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]


// =========================================================
// CLIENTS
// =========================================================

const CUSTOMER_ROLES = [
  ...ALL_ADMIN,
  ...AGENT_ROLES,
  "gerant_magasin",
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]


// =========================================================
// VENTES
// =========================================================

const SALES_VIEW_ROLES = [
  ...ALL_ADMIN,
  ...AGENT_ROLES,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "caissier_central",
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const SALES_CREATE_ROLES = [
  ...ALL_ADMIN,
  ...AGENT_ROLES,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const SALE_EDIT_ROLES = [
  ...ALL_ADMIN,
  ...AGENT_ROLES,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]


// =========================================================
// CAISSE
// =========================================================

const CASHIER_ROLES = [
  ...ALL_ADMIN,
  "caissier_central",
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const EXPENSE_ROLES = [
  ...ALL_ADMIN,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]

const DEBT_ROLES = [
  ...ALL_ADMIN,
  "gerant_magasin",
  "caissier_central",
  "gestionnaire_operations",
  "admin_maison_djo",
  "gestionnaire_maison_djo",
  "admin_depot_relais",
  "gestionnaire_depot_relais",
]


// =========================================================
// STOCK
// =========================================================

const STOCK_ORDER_ROLES = [
  ...ALL_ADMIN,
  ...MAISON_DJO_ROLES,
  ...DEPOT_RELAIS_MANAGER_ROLES,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "gestionnaire_stock",
  "gestionnaire_operations",
]

const STOCK_VIEW_ROLES = [
  ...ALL_ADMIN,
  ...SHOP_MAISON_DJO_ROLES,
  ...SHOP_DEPOT_RELAIS_ROLES,
  "gestionnaire_stock",
  "controleur_stock",
  "gestionnaire_operations",
  ...MAISON_DJO_ROLES,
  ...DEPOT_RELAIS_MANAGER_ROLES,
]

const WAREHOUSE_DASHBOARD_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
  "controleur_stock",
]

const WAREHOUSE_MANAGE_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_operations",
  "gestionnaire_stock",
]

const STOCK_MANAGER_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_stock",
  "gestionnaire_operations",
  "admin_maison_djo",
  "stock_maison_djo",
  "admin_depot_relais",
  "stock_depot_relais",
]

const STOCK_TRANSFER_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_stock",
  "gestionnaire_operations",
  "admin_maison_djo",
  "stock_maison_djo",
  "admin_depot_relais",
  "stock_depot_relais",
]

const STOCK_AUDIT_ROLES = [
  ...ALL_ADMIN,
  "gestionnaire_stock",
  "controleur_stock",
  "admin_maison_djo",
  "stock_maison_djo",
  "admin_depot_relais",
  "stock_depot_relais",
]



// =========================================================
// COMPTABILITÉ & FINANCE
// =========================================================



// =========================================================
// ACHATS & FOURNISSEURS
// =========================================================

const PURCHASE_VIEW_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
  "controleur_stock",
]

const PURCHASE_REQUEST_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
]

const PURCHASE_ORDER_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
]

const PURCHASE_RECEIPT_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
  "controleur_stock",
]

const SUPPLIER_INVOICE_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "caissier_central",
]

const SUPPLIER_PAYMENT_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "caissier_central",
]


// =========================================================
// PRODUCTION
// =========================================================

const PRODUCTION_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "gestionnaire_stock",
]



// =========================================================
// COMPTABILITÉ & FINANCE
// =========================================================

const ACCOUNTING_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
  "caissier_central",
]


// =========================================================
// RESSOURCES HUMAINES
// =========================================================

const HR_ROLES = [
  ...ALL_ADMIN,
  "dg",
  "gestionnaire_operations",
]


// =========================================================
// ADMINISTRATION
// =========================================================

const ADMINISTRATION_ROLES = [...ALL_ADMIN]


// =========================================================
// ENVIRONNEMENT WEB / MOBILE
// =========================================================

function isNativeAppRuntime() {
  const protocol = window.location.protocol
  const hostname = window.location.hostname.toLowerCase()
  const capacitor = window.Capacitor

  return (
    protocol === "capacitor:" ||
    protocol === "file:" ||
    hostname.startsWith("app.") ||
    Boolean(capacitor?.isNativePlatform?.())
  )
}


// =========================================================
// PAGE PUBLIQUE
// =========================================================

function PublicHomeRoute() {
  const user = localStorage.getItem("kongosys_user")
  const role = localStorage.getItem("kongosys_role")

  if (isNativeAppRuntime()) {
    return (
      <Navigate
        to={user && role ? getRoleHomePage(role) : "/login"}
        replace
      />
    )
  }

  if (user && role) {
    return <Navigate to={getRoleHomePage(role)} replace />
  }

  return <LandingPage />
}


// =========================================================
// ROUTES
// =========================================================

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ================================================= */}
        {/* PUBLIC / AUTH */}
        {/* ================================================= */}

        <Route path="/" element={<PublicHomeRoute />} />
        <Route path="/login" element={<LoginPage />} />


        {/* ================================================= */}
        {/* PILOTAGE */}
        {/* ================================================= */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={PILOTAGE_ROLES}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard-pro"
          element={
            <ProtectedRoute allowedRoles={PILOTAGE_ROLES}>
              <DashboardProPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/warehouse-dashboard"
          element={
            <ProtectedRoute allowedRoles={WAREHOUSE_DASHBOARD_ROLES}>
              <WarehouseDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/logistics-dashboard"
          element={
            <ProtectedRoute allowedRoles={LOGISTICS_ROLES}>
              <LogisticsDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/maison-djo-dashboard"
          element={
            <ProtectedRoute allowedRoles={MAISON_DJO_DASHBOARD_ROLES}>
              <MaisonDjoDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/depot-relais-dashboard"
          element={
            <ProtectedRoute allowedRoles={DEPOT_RELAIS_DASHBOARD_ROLES}>
              <DepotRelaisDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/agent-commercial-dashboard"
          element={
            <ProtectedRoute allowedRoles={AGENT_DASHBOARD_ROLES}>
              <AgentCommercialDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reporting"
          element={
            <ProtectedRoute allowedRoles={PILOTAGE_ROLES}>
              <ReportingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activity-logs"
          element={
            <ProtectedRoute allowedRoles={[...ALL_ADMIN, "dg"]}>
              <ActivityLogsPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* STRUCTURE / ADMINISTRATION */}
        {/* ================================================= */}

        <Route
          path="/organizations"
          element={
            <ProtectedRoute allowedRoles={ADMINISTRATION_ROLES}>
              <OrganizationsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/roles"
          element={
            <ProtectedRoute allowedRoles={ADMINISTRATION_ROLES}>
              <RolesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute allowedRoles={ADMINISTRATION_ROLES}>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stores"
          element={
            <ProtectedRoute allowedRoles={STRUCTURE_ROLES}>
              <StoresPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/warehouses"
          element={
            <ProtectedRoute allowedRoles={WAREHOUSE_MANAGE_ROLES}>
              <WarehousesPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* CATALOGUE */}
        {/* ================================================= */}

        <Route
          path="/categories"
          element={
            <ProtectedRoute allowedRoles={CATALOGUE_ROLES}>
              <CategoriesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/products"
          element={
            <ProtectedRoute allowedRoles={CATALOGUE_ROLES}>
              <ProductsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings/product-prices"
          element={
            <ProtectedRoute allowedRoles={PRICE_SETTINGS_ROLES}>
              <ProductPricesPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* ACHATS & FOURNISSEURS */}
        {/* ================================================= */}

        <Route
          path="/suppliers"
          element={
            <ProtectedRoute allowedRoles={PURCHASE_VIEW_ROLES}>
              <SuppliersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/purchase-requests"
          element={
            <ProtectedRoute allowedRoles={PURCHASE_REQUEST_ROLES}>
              <PurchaseRequestsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/purchase-orders"
          element={
            <ProtectedRoute allowedRoles={PURCHASE_ORDER_ROLES}>
              <PurchaseOrdersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/purchase-receipts"
          element={
            <ProtectedRoute allowedRoles={PURCHASE_RECEIPT_ROLES}>
              <PurchaseReceiptsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/supplier-invoices"
          element={
            <ProtectedRoute allowedRoles={SUPPLIER_INVOICE_ROLES}>
              <SupplierInvoicesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/supplier-payments"
          element={
            <ProtectedRoute allowedRoles={SUPPLIER_PAYMENT_ROLES}>
              <SupplierPaymentsPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* PRODUCTION */}
        {/* ================================================= */}

        <Route
          path="/production/boms"
          element={
            <ProtectedRoute allowedRoles={PRODUCTION_ROLES}>
              <ProductionBomsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/orders"
          element={
            <ProtectedRoute allowedRoles={PRODUCTION_ROLES}>
              <ProductionOrdersPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* RESSOURCES HUMAINES */}
        {/* ================================================= */}

        <Route
          path="/hr/dashboard"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <HrDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/employees"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <EmployeesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/departments-positions"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <DepartmentsPositionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/attendance"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <AttendancePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/leaves"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <LeaveRequestsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/payroll"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <PayrollPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/contracts-documents"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <ContractsDocumentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hr/performance"
          element={
            <ProtectedRoute allowedRoles={HR_ROLES}>
              <PerformancePage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* CLIENTS & VENTES */}
        {/* ================================================= */}

        <Route
          path="/customers"
          element={
            <ProtectedRoute allowedRoles={CUSTOMER_ROLES}>
              <CustomersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute allowedRoles={SALES_VIEW_ROLES}>
              <SalesListPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/new"
          element={
            <ProtectedRoute allowedRoles={SALES_CREATE_ROLES}>
              <SalesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/:saleId"
          element={
            <ProtectedRoute allowedRoles={SALES_VIEW_ROLES}>
              <SaleDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales/:saleId/edit"
          element={
            <ProtectedRoute allowedRoles={SALE_EDIT_ROLES}>
              <SalesPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* PAIEMENTS / CAISSE */}
        {/* ================================================= */}

        <Route
          path="/payments"
          element={
            <ProtectedRoute allowedRoles={CASHIER_ROLES}>
              <PaymentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/deposits"
          element={
            <ProtectedRoute allowedRoles={CASHIER_ROLES}>
              <DepositsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/store-reconciliations"
          element={
            <ProtectedRoute allowedRoles={CASHIER_ROLES}>
              <StoreReconciliationsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/expenses"
          element={
            <ProtectedRoute allowedRoles={EXPENSE_ROLES}>
              <ExpensesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/debts"
          element={
            <ProtectedRoute allowedRoles={DEBT_ROLES}>
              <DebtsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/debt-payments"
          element={
            <ProtectedRoute allowedRoles={CASHIER_ROLES}>
              <DebtPaymentsPage />
            </ProtectedRoute>
          }
        />



        {/* ================================================= */}
        {/* COMPTABILITÉ & FINANCE */}
        {/* ================================================= */}

        <Route
          path="/accounting/dashboard"
          element={
            <ProtectedRoute allowedRoles={ACCOUNTING_ROLES}>
              <AccountingDashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounting/chart-of-accounts"
          element={
            <ProtectedRoute allowedRoles={ACCOUNTING_ROLES}>
              <ChartOfAccountsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounting/journal-entries"
          element={
            <ProtectedRoute allowedRoles={ACCOUNTING_ROLES}>
              <JournalEntriesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounting/general-ledger"
          element={
            <ProtectedRoute allowedRoles={ACCOUNTING_ROLES}>
              <GeneralLedgerPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounting/trial-balance"
          element={
            <ProtectedRoute allowedRoles={ACCOUNTING_ROLES}>
              <TrialBalancePage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* STOCK & INVENTAIRE */}
        {/* ================================================= */}

        <Route
          path="/stock-orders"
          element={
            <ProtectedRoute allowedRoles={STOCK_ORDER_ROLES}>
              <StockOrdersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stock-balances"
          element={
            <ProtectedRoute allowedRoles={STOCK_VIEW_ROLES}>
              <StockBalancesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stock-alerts"
          element={
            <ProtectedRoute allowedRoles={STOCK_VIEW_ROLES}>
              <StockAlertsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stock-movements"
          element={
            <ProtectedRoute allowedRoles={STOCK_MANAGER_ROLES}>
              <StockMovementsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stock-transfers"
          element={
            <ProtectedRoute allowedRoles={STOCK_TRANSFER_ROLES}>
              <StockTransfersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/stock-audits"
          element={
            <ProtectedRoute allowedRoles={STOCK_AUDIT_ROLES}>
              <StockAuditsPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* LOGISTIQUE */}
        {/* ================================================= */}

        <Route
          path="/vehicles"
          element={
            <ProtectedRoute allowedRoles={LOGISTICS_ROLES}>
              <VehiclesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/drivers"
          element={
            <ProtectedRoute allowedRoles={LOGISTICS_ROLES}>
              <DriversPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery-trips"
          element={
            <ProtectedRoute allowedRoles={LOGISTICS_ROLES}>
              <DeliveryTripsPage />
            </ProtectedRoute>
          }
        />


        {/* ================================================= */}
        {/* ROUTE INCONNUE */}
        {/* ================================================= */}

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes
